/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Organization } from '../model/organization';
import { OrganizationCreateUpdate } from '../model/organizationCreateUpdate';
import { OrganizationWorkplaces } from '../model/organizationWorkplaces';
import { PatchedOrganizationCreateUpdate } from '../model/patchedOrganizationCreateUpdate';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OrganizationService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve the organization associated with the director&#x27;s kindergarten
     * Retrieve the organization associated with the director&#x27;s kindergarten.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationMyOrganizationRetrieve(observe?: 'body', reportProgress?: boolean): Observable<Organization>;
    public organizationMyOrganizationRetrieve(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Organization>>;
    public organizationMyOrganizationRetrieve(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Organization>>;
    public organizationMyOrganizationRetrieve(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Organization>('get',`${this.basePath}/organization/my_organization/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Partially update organization if it belongs to director.
     * @param id A UUID string identifying this organization.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationPartialUpdate(id: string, body?: PatchedOrganizationCreateUpdate, observe?: 'body', reportProgress?: boolean): Observable<OrganizationCreateUpdate>;
    public organizationPartialUpdate(id: string, body?: PatchedOrganizationCreateUpdate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrganizationCreateUpdate>>;
    public organizationPartialUpdate(id: string, body?: PatchedOrganizationCreateUpdate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrganizationCreateUpdate>>;
    public organizationPartialUpdate(id: string, body?: PatchedOrganizationCreateUpdate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling organizationPartialUpdate.');
        }


        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<OrganizationCreateUpdate>('patch',`${this.basePath}/organization/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update organization if it belongs to director.
     * @param body 
     * @param id A UUID string identifying this organization.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationUpdate(body: OrganizationCreateUpdate, id: string, observe?: 'body', reportProgress?: boolean): Observable<OrganizationCreateUpdate>;
    public organizationUpdate(body: OrganizationCreateUpdate, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrganizationCreateUpdate>>;
    public organizationUpdate(body: OrganizationCreateUpdate, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrganizationCreateUpdate>>;
    public organizationUpdate(body: OrganizationCreateUpdate, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling organizationUpdate.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling organizationUpdate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<OrganizationCreateUpdate>('put',`${this.basePath}/organization/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all workplaces (kindergartens) within the users organization
     * Get all workplaces (kindergartens) within the users organization.  This endpoint provides: - List of all kindergartens in the organization - Which kindergarten is currently active (logged into) - License information for each kindergarten (demo/trial expiration, etc.) - Number of teachers in each kindergarten - Number of children (active and archived) in each kindergarten - Which kindergarten is primary for the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationWorkplacesRetrieve(observe?: 'body', reportProgress?: boolean): Observable<OrganizationWorkplaces>;
    public organizationWorkplacesRetrieve(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrganizationWorkplaces>>;
    public organizationWorkplacesRetrieve(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrganizationWorkplaces>>;
    public organizationWorkplacesRetrieve(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OrganizationWorkplaces>('get',`${this.basePath}/organization/workplaces/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
